import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RESUME_HIRING_ACTIONS, ResumeHiringDialogData, ResumeHiringDialogResult } from 'src/app/global/models/dialog/resume-hiring-data';


@Component({
  selector: 'app-resume-hiring',
  templateUrl: './resume-hiring.component.html',
  styleUrls: ['./resume-hiring.component.scss']
})
export class ResumeHiringComponent {

  constructor(
    public dialogRef: MatDialogRef<ResumeHiringComponent, ResumeHiringDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ResumeHiringDialogData
  ) { }

  onPrimaryActionClick(): void {
    this.dialogRef.close({
      action: RESUME_HIRING_ACTIONS.PRIMARY
    });
  }

  onSecondaryActionClick(): void {
    this.dialogRef.close({
      action: RESUME_HIRING_ACTIONS.SECONDARY
    });
  }

  onCloseClick(): void {
    this.dialogRef.close({
      action: RESUME_HIRING_ACTIONS.CLOSE
    });
  }
}
